import _ from "lodash";

export interface OtherSequenceParametersSettingData {
    id: number;
    parameter_name: string;
    product: string;
    order: string;
    testing_station: string;
    measurement_name: string;
    measurement_id: string;
    export_file_name: string;
    created_at: string;
    created_by_name: string;
}


export interface TestingDataFilter {
    testing_result_id: number;
    logic: 'and' | 'or'
    field: string;
    operator?: string;
    value?:  any;
    children?: TestingDataFilter[];
}


export interface TestingDataFilterData {
    id: number;
    name: string;
    testing_result_id: number;
    description: string;
    filters: TestingDataFilter[];

    created_at: string;
    created_by_name: string;

    product?: string;
    order?: string;
    testing_station?: string;
}

export interface TestingDataBatchSerialData {
    id: number;
    product: string;
    serial_pattern: string;
    created_at: string;
    created_by_name: string;
}

export interface TestingResultOptionsData {
    station_ids: string[],
    employees: string[],
    hardware_versions: string[],
    firmware_versions: string[],
    measurements: {name: string, export_file_name?: string, key: string, data_type: number} [],
    serial_types: string[]
}


export interface FieldConfigs {
    result_id: number,
    fields: string[],
    types: {[field: string]: [string, any?]}
}

export function generateFilterFieldsConfig(testingResultOptions: TestingResultOptionsData, result_id: number): FieldConfigs {
    const result: FieldConfigs = { 
        result_id,
        fields: ['serial_number', 'refurbishment_serial', 'file_name', 'date', 'status', 'hardware_version', 'firmware_version', 'testing_station_id', 'employee_id', 'custom_limit'],
        types: {
            'children': ['filter'],
            'date': ['datetime'],
            'status': ['enum', [[1, 'Pass'], [2, 'Fail'], [3, 'Invalid']]],
            'custom_limit': ['limit', testingResultOptions.measurements]
        }
    }

    result.types['hardware_version'] = ['enum', testingResultOptions.hardware_versions.map(v => [v, v])]
    result.types['firmware_version'] = ['enum', testingResultOptions.firmware_versions.map(v => [v, v])]
    result.types['testing_station_id'] = ['enum', testingResultOptions.station_ids.map(v => [v, v])]
    result.types['employee_id'] = ['enum', testingResultOptions.employees.map(v => [v, v])]

    for (const st of testingResultOptions.serial_types) {
        result.fields.push(`other_sn__${st}#${st}`)
    }
    
    for (const field of ['pass_on', 'fail_on', 'invalid_on', 'unknown_on']) {
        result.fields.push(field);
        result.types[field] = ['enum', testingResultOptions.measurements.map(m => [m.key, m.name])]
    }
    

    result.fields.push('children')

    return result;
}